import { renderSlot as _renderSlot, vModelDynamic as _vModelDynamic, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-control-input d-control-input--appearance_bordered" }
const _hoisted_2 = ["type"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIcon = _resolveComponent("AppIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "label"),
    _withDirectives(_createElementVNode("input", _mergeProps({
      class: "d-control-input__element",
      autocomplete: "off"
    }, _ctx.$attrs, {
      type: $setup.inputType,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.val) = $event)),
      onInput: $setup.setValue
    }), null, 16, _hoisted_2), [
      [_vModelDynamic, $setup.val]
    ]),
    ($setup.isPasswordField)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "change-type",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleType()))
        }, [
          _createVNode(_component_AppIcon, {
            name: $setup.inputType === $setup.p ? 'i-eye' : 'i-eye-slash'
          }, null, 8, ["name"])
        ]))
      : _createCommentVNode("", true)
  ]))
}